import * as React from "react";
import { Switch, Route } from "react-router-dom";
import LoginHelp from "../../components/login/loginScreen/loginHelp";
import ForgotLoginIdScreen from "../../components/login/loginScreen/forgotLoginIdScreen";
import LeadFormScreen from "../../components/login/loginScreen/leadFormScreen";
import MergeIdScreen from "../../components/login/loginScreen/mergeIdScreen";
import ChangePasswordScreen from "../../components/login/loginScreen/changePasswordScreen";
import LinkAadharScreen from "../../components/login/loginScreen/linkAadharScreen";
import RmRatingScreen from "../../components/login/loginScreen/rmRatingScreen";
import OpenAccountScreen from "../../components/login/loginScreen/openAccountScreen";
import LoginCtrl from "../../components/login/loginCtrl";
import ForgotScreen from "../../components/login/loginScreen/forgotScreen";
import TncConsentScreen from "../../components/login/loginScreen/tncConsentScreen";
import PostLogin from "../postLogin";
import ResetCredsScreen from "../../components/login/loginScreen/resetCredsScreen";
import LoginStatusScreen from "../../components/login/loginScreen/loginStatusScreen";

const LoginRouting = () => {
	return (
		<Switch>
			<Route path="/login" exact component={LoginCtrl} />
			<Route path="/login/help" exact component={LoginHelp} />
			<Route path="/login/forgot-loginid" exact component={ForgotLoginIdScreen} />
			<Route path="/login/forgot-password" exact component={ForgotScreen} />
			<Route path="/login/unblock-account" exact component={ForgotScreen} />
			<Route path="/login/forgot-yob" exact component={ForgotScreen} />
			<Route path="/login/lead-form" exact component={LeadFormScreen} />
			<Route path="/login/merge" exact component={MergeIdScreen} />
			<PostLogin path="/login/change-password" exact component={ChangePasswordScreen} />
			<Route path="/login/link-aadhar" exact component={LinkAadharScreen} />
			<Route path="/login/rm-rating" exact component={RmRatingScreen} />
			<Route path="/login/open-account" exact component={OpenAccountScreen} />
			<Route path="/login/tnc" exact component={TncConsentScreen} />
		</Switch>
	);
};
export default LoginRouting;
